import { render } from "./values-list.vue?vue&type=template&id=c70e598c"
import script from "./values-list.vue?vue&type=script&lang=js"
export * from "./values-list.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\yrabie\\Documents\\Projects\\Awsat Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__